import { GridAgColumn } from '../../grid/interfaces/GridAgColumn';

export class GridColumnService {
  static getColumnByName(name: string, columns: GridAgColumn[]): GridAgColumn | undefined {
    return columns.find(column => column.field === name);
  }
}
